import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';

import { UPDATE_CEP_COUNTS_FORM_NAME } from 'Common/FormEnum';
import { UpdateCEPCountsFieldEnum as Fields } from 'Common/FieldEnum';
import { DatePickerField } from 'Common/SemanticWrapper';

class UpdateCEPCountsFormContainer extends Component {
  render() {
    const { loading } = this.props;
    const currentDate = moment();
    return (
      <Fragment>
        <Form name={UPDATE_CEP_COUNTS_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Date'}
                  name={Fields.FromDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={currentDate}
                  maxDate={currentDate}
                  disabled={loading}
                  dateFormat={'MM/YYYY'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromFate] = 'Enter a valid Date.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'Date must be set.';
  }
  if (moment(values[Fields.FromDate]).isAfter(moment())) {
    errors[Fields.FromDate] = 'Date cannot be in the future';
  }
  return errors;
};

const UpdateCEPCountsForm = reduxForm({
  form: UPDATE_CEP_COUNTS_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(connect()(UpdateCEPCountsFormContainer)));

export { UpdateCEPCountsForm };



// WEBPACK FOOTER //
// ./src/pages/updatecepcounts/components/UpdateCEPCountsForm.js